import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/UseAuth';
import Spinner from '../layout/Spinner';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useLangNavigate } from '../../hooks/useLangNavigate';

const CreatorRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  const langNavigate = useLangNavigate();
  const [redirectPath, setRedirectPath] = useState(null);

  useEffect(() => {
    if (isLoading) {
      return;
    }

    let targetPath = null;
    if (!isAuthenticated) {
      targetPath = '/login';
    } else if (user && user.profileType !== 'creator') {
      targetPath = '/explore';
    } else if (user && user.verification?.status !== 'verified') {
      if (!location.pathname.endsWith('/my/verification')) {
        targetPath = '/my/verification';
      }
    } else if (user) {
      // --- INICIO DE LA MODIFICACIÓN ---
      // Comprobar si MP está conectado
      const isMercadoPagoConnected =
        user.mercadoPagoConnect?.connected === true;
      // Comprobar si el admin le dio permiso para omitir el requisito
      const canBypassRequirement =
        user.platformSettings?.bypassMercadoPagoRequirement === true;

      if (
        !isMercadoPagoConnected && // Si NO está conectado
        !canBypassRequirement && // Y TAMPOCO tiene el permiso para omitir
        !location.pathname.endsWith('/dashboard/settings') // Y no está ya en la página de configuración
      ) {
        // Entonces, redirigir
        targetPath = '/dashboard/settings';
      }
      // --- FIN DE LA MODIFICACIÓN ---
    }

    setRedirectPath(targetPath);
  }, [isLoading, isAuthenticated, user, location.pathname]);

  // --- INICIO DE LA CORRECCIÓN ---
  // Se elimina 'location' del array de dependencias para romper el bucle infinito.
  // Este efecto ahora solo se ejecuta cuando 'redirectPath' cambia de null a una ruta.

  useEffect(() => {
    if (redirectPath) {
      langNavigate(redirectPath, { state: { from: location }, replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectPath, langNavigate]);
  // --- FIN DE LA CORRECCIÓN ---

  if (isLoading || redirectPath) {
    return <Spinner fullScreen={true} message={t('general.loading_user')} />;
  }

  return <Outlet />;
};

export default CreatorRoute;
